import { Link } from "@/lib/router-compat";
import { ChevronRight, Phone } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/sections/Footer";
import { RelatedPages } from "@/components/RelatedPages";
import { SITE_URL, ORG_ID } from "@/components/schemaConstants";
import { page1 } from "./learnDataP1";
import { page2 } from "./learnDataP2";
import { page3 } from "./learnDataP3";
import { page4 } from "./learnDataP4";
import { page5 } from "./learnDataP5";
import { page6 } from "./learnDataP6";
import { page7 } from "./learnDataP7";
import { page8 } from "./learnDataP8";
import { page9 } from "./learnDataP9";
import { page10 } from "./learnDataP10";
import { whereCanIGetSaint } from "./learnDataWhereCanIGetSaint";
import { saintNearMe } from "./learnDataSaintNearMe";
import { saintFlorida } from "./learnDataSaintFlorida";
import { saintCost } from "./learnDataSaintCost";
import { doesInsuranceCoverSaint } from "./learnDataDoesInsuranceCoverSaint";
import { saintMiami } from "./learnDataSaintMiami";
import { saintFortLauderdale } from "./learnDataSaintFortLauderdale";
import { pageSaintBocaRaton } from "./learnDataSaintBocaRaton";
import { pageSaintEastCoast } from "./learnDataSaintEastCoast";
import { pageHowFastSaint } from "./learnDataHowFastSaint";
import { pageWhatToExpect } from "./learnDataWhatToExpect";
import { page5DayTms } from "./learnData5DayTms";
import { pageFastTrd } from "./learnDataFastTrd";
import { pageAntidepressantsDontWork } from "./learnDataAntidepressantsDontWork";
import { pageBeyondMedication } from "./learnDataBeyondMedication";
import { pageFmriGuided } from "./learnDataFmriGuided";
import { pageSaintVsTraditional } from "./learnDataSaintVsTraditional";
import { pageSaintVsSpravato } from "./learnDataSaintVsSpravato";
import { pageSaintVsKetamine } from "./learnDataSaintVsKetamine";
import { pageBcbsSaint } from "./learnDataBcbsSaint";
import { pageWhyAntidepressantNotWorking } from "./learnDataWhyAntidepressantNotWorking";
import { pageCanTmsHelpAfterAntidepressants } from "./learnDataCanTmsHelpAfterAntidepressants";
import { pageCanSaintHelpAfterMeds } from "./learnDataCanSaintHelpAfterMeds";
import { pageWhatComesAfterMedTherapy } from "./learnDataWhatComesAfterMedTherapy";
import { pageHowManyAntidepressants } from "./learnDataHowManyAntidepressants";
import { pageTwoAntidepressantsDontWork } from "./learnDataTwoAntidepressantsDontWork";
import { pageNothingWorks } from "./learnDataNothingWorks";
import { pageNoMoreMedication } from "./learnDataNoMoreMedication";
import { pageFastestTreatment } from "./learnDataFastestTreatment";
import { pageIsSaintAvailableNearMe } from "./learnDataIsSaintAvailableNearMe";
import { pageWhatIsVerifiedProvider } from "./learnDataWhatIsVerifiedProvider";
import { pageSaintTmsResults } from "./learnDataSaintTmsResults";
import { pageHowToFindSaintProvider } from "./learnDataHowToFindSaintProvider";
import { pageQuestionsToAskProvider } from "./learnDataQuestionsToAskProvider";
import { pageOutpatientSaint } from "./learnDataOutpatientSaint";
import { pageSaintBrainTarget } from "./learnDataSaintBrainTarget";
import { pageSaintBetweenSessions } from "./learnDataSaintBrainTarget";
import { pageSaintStartQuickly } from "./learnDataSaintBrainTarget";
import { pageSaintTravelCompanion } from "./learnDataSaintTravelCompanion";
// pageTiredOfFeelingDepressed moved to learnDataTiredOfFeelingDepressed.tsx
import { pageNothingWorksForDepression } from "./learnDataEmotionalSearches";
import { pageLostHope } from "./learnDataEmotionalSearches";
import { pageDepressionKeepsComingBack } from "./learnDataEmotionalSearches";
import { pageDepressedForYears } from "./learnDataEmotionalSearches";
import { pageDontWantToChangeAntidepressants } from "./learnDataEmotionalSearches";
import { pageOptionsIfTherapyDoesntHelp } from "./learnDataEmotionalSearches";
import { pageDepressionImpossibleToTreat } from "./learnDataEmotionalSearches";
import { pageTravelForSaint } from "./learnDataTravelForSaint";
import { pageSaintVsEct } from "./learnDataComparisons";
import { pageSaintVsAntidepressants } from "./learnDataComparisons";
import { pageTmsVsMedication as pageTmsVsMedicationForDepression } from "./learnDataComparisons";
import { pageAcceleratedVsConventional } from "./learnDataComparisons";
import { pageSaintVsAccelerated } from "./learnDataComparisons";
// SAINT protocol questions
import { pageHowDoesSaintWork } from "./learnDataHowDoesSaintWork";
import { pageSaintHowLongTake } from "./learnDataSaintHowLongTake";
import { pageSaintSessions } from "./learnDataSaintSessions";
import { pageSaintMri } from "./learnDataSaintMri";
import { pageSaintAnesthesia } from "./learnDataSaintAnesthesia";
import { pageSaintAnesthesiaMedication } from "./learnDataSaintAnesthesiaMedication";
import { pageSaintSideEffects } from "./learnDataSaintSideEffects";
import { pageSaintFeelLike } from "./learnDataSaintFeelLike";
import { pageSaintDriveWork } from "./learnDataSaintDriveWork";
import { pageSaintWorkDuringTreatment } from "./learnDataSaintWorkDuringTreatment";
import { pageSaintOutpatientHospital } from "./learnDataSaintOutpatientHospital";
import { pageSaintEligibility } from "./learnDataSaintEligibility";
import { pageSaintAfterTreatment } from "./learnDataSaintAfterTreatment";
import { pageSaintForTrd } from "./learnDataSaintForTrd";
import { pageSaintAfterMedicationFailure } from "./learnDataSaintAfterMedicationFailure";
import { pageSaintHowFastVsTms } from "./learnDataSaintHowFastVsTms";
import { pageSaintQuestions } from "./learnDataSaintQuestions";
import { pageSaintCostHub } from "./learnDataSaintCostHub";
// Treatment failure / TRD
import { pageSignsOfTrd } from "./learnDataSignsOfTrd";
import { pageNewTreatmentsForTrd } from "./learnDataNewTreatmentsForTrd";
import { pageTmsAfterAntidepressantsFail } from "./learnDataTmsAfterAntidepressantsFail";
import { pageCanDepressionResistMedication } from "./learnDataCanDepressionResistMedication";
// Emotional / patient-language
import { pageDepressionWontGoAway as pageDepressionWontGoAwayStandalone } from "./learnDataDepressionWontGoAway";
import { pageDepressionComingBack as pageDepressionComingBackStandalone } from "./learnDataDepressionComingBack";
import { pageStillDepressedOnMedication } from "./learnDataStillDepressedOnMedication";
import { pageTiredOfFeelingDepressed as pageTiredOfFeelingDepressedStandalone } from "./learnDataTiredOfFeelingDepressed";
import { pageTherapyNotHelping } from "./learnDataTherapyNotHelping";
// Alternatives / advanced
import { pageAdvancedDepressionTreatment } from "./learnDataAdvancedDepressionTreatment";
import { pageAlternativeToAntidepressants } from "./learnDataAlternativeToAntidepressants";
import { pageAlternativeToEct } from "./learnDataAlternativeToEct";
import { pageFastDepressionTreatment } from "./learnDataFastDepressionTreatment";
import { pageTmsVsMedication } from "./learnDataTmsVsMedication";
import { pageSaintTreatmentWeekDayByDay } from "./learnDataSaintDayByDay";
import { pageTmsVsSpravato } from "./learnDataTmsVsSpravato";
import {
  pageHowToFindLegitimateSaintProvider,
  pageWhatToLookForInDepressionCenter,
} from "./learnDataProviderQuestions";
import { pageWhereCanIGetSaintTreatment } from "./learnDataWhereCanIGetSaintTreatment";
import { pageSaintTmsLocations } from "./learnDataSaintTmsLocations";
import { pageIsSaintCoveredByInsurance } from "./learnDataIsSaintCoveredByInsurance";
import { pageWhatIsSaintTreatmentForDepression } from "./learnDataWhatIsSaintTreatmentForDepression";
import { pageSaintTmsProtocol } from "./learnDataSaintTmsProtocol";
import { pageStanfordAcceleratedIntelligentNeuromodulationTherapy } from "./learnDataStanfordAcceleratedIntelligentNeuromodulationTherapy";
import { pageCanDepressionCausePhysicalPain } from "./pageCanDepressionCausePhysicalPain";
import { pageAlwaysTiredDepressionFatigue } from "./pageAlwaysTiredDepressionFatigue";
import { pageAnxietyChestTightness } from "./pageAnxietyChestTightness";
import { pageCantStopCrying } from "./pageCantStopCrying";
import { pageAnxietyWorseInMorning } from "./pageAnxietyWorseInMorning";
import { pageHighFunctioningDepression } from "./learnDataHighFunctioningDepression";
import type { LearnPageData } from "./learnShared";

const allPages: LearnPageData[] = [
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  whereCanIGetSaint,
  saintNearMe,
  saintFlorida,
  saintCost,
  doesInsuranceCoverSaint,
  saintMiami,
  saintFortLauderdale,
  pageSaintBocaRaton,
  pageSaintEastCoast,
  pageHowFastSaint,
  pageWhatToExpect,
  page5DayTms,
  pageFastTrd,
  pageAntidepressantsDontWork,
  pageBeyondMedication,
  pageFmriGuided,
  pageSaintVsTraditional,
  pageSaintVsSpravato,
  pageSaintVsKetamine,
  pageBcbsSaint,
  pageWhatIsVerifiedProvider,
  pageHowToFindSaintProvider,
  pageQuestionsToAskProvider,
  pageOutpatientSaint,
  pageWhyAntidepressantNotWorking,
  pageCanTmsHelpAfterAntidepressants,
  pageCanSaintHelpAfterMeds,
  pageWhatComesAfterMedTherapy,
  pageHowManyAntidepressants,
  pageTwoAntidepressantsDontWork,
  pageNothingWorks,
  pageNoMoreMedication,
  pageFastestTreatment,
  pageIsSaintAvailableNearMe,
  pageSaintBrainTarget,
  pageSaintBetweenSessions,
  pageSaintStartQuickly,
  pageSaintTravelCompanion,
  pageNothingWorksForDepression,
  pageLostHope,
  pageDepressionKeepsComingBack,
  pageDepressedForYears,
  pageDontWantToChangeAntidepressants,
  pageOptionsIfTherapyDoesntHelp,
  pageDepressionImpossibleToTreat,
  pageTravelForSaint,
  pageSaintVsEct,
  pageSaintVsAntidepressants,
  pageTmsVsMedicationForDepression,
  pageAcceleratedVsConventional,
  pageSaintVsAccelerated,
  // SAINT protocol questions
  pageHowDoesSaintWork,
  pageSaintHowLongTake,
  pageSaintSessions,
  pageSaintMri,
  pageSaintAnesthesia,
  pageSaintAnesthesiaMedication,
  pageSaintSideEffects,
  pageSaintFeelLike,
  pageSaintDriveWork,
  pageSaintWorkDuringTreatment,
  pageSaintOutpatientHospital,
  pageSaintEligibility,
  pageSaintAfterTreatment,
  pageSaintForTrd,
  pageSaintAfterMedicationFailure,
  pageSaintHowFastVsTms,
  pageSaintQuestions,
  pageSaintCostHub,
  // Treatment failure / TRD
  pageSignsOfTrd,
  pageNewTreatmentsForTrd,
  pageTmsAfterAntidepressantsFail,
  pageCanDepressionResistMedication,
  // Emotional / patient-language
  pageDepressionWontGoAwayStandalone,
  pageDepressionComingBackStandalone,
  pageStillDepressedOnMedication,
  pageTiredOfFeelingDepressedStandalone,
  pageTherapyNotHelping,
  // Alternatives / advanced
  pageAdvancedDepressionTreatment,
  pageAlternativeToAntidepressants,
  pageAlternativeToEct,
  pageFastDepressionTreatment,
  pageTmsVsMedication,
  pageSaintTreatmentWeekDayByDay,
  pageTmsVsSpravato,
  pageHowToFindLegitimateSaintProvider,
  pageWhatToLookForInDepressionCenter,
  pageWhereCanIGetSaintTreatment,
  pageSaintTmsLocations,
  pageIsSaintCoveredByInsurance,
  pageWhatIsSaintTreatmentForDepression,
  pageSaintTmsProtocol,
  pageStanfordAcceleratedIntelligentNeuromodulationTherapy,
  pageCanDepressionCausePhysicalPain,
  pageAlwaysTiredDepressionFatigue,
  pageAnxietyChestTightness,
  pageCantStopCrying,
  pageAnxietyWorseInMorning,
  pageHighFunctioningDepression,
  pageSaintTmsResults,
];

export const hubSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "MedicalWebPage",
      "@id": `${SITE_URL}/learn#webpage`,
      name: "Patient Education — Neuro Wellness TMS Centers of America",
      url: `${SITE_URL}/learn`,
      description:
        "Plain-language patient education on TMS, SAINT® TMS, accelerated TMS, Spravato, treatment-resistant depression, and how these treatments compare.",
      inLanguage: "en-US",
      publisher: { "@id": ORG_ID },
      audience: { "@type": "MedicalAudience", audienceType: "Patient" },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `${SITE_URL}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Patient Education",
          item: `${SITE_URL}/learn`,
        },
      ],
    },
  ],
};

const sharedRelated = [
  {
    title: "SAINT® Accelerated TMS",
    href: "/saint",
    description: "The 5-day, fMRI-guided protocol offered at our clinic",
  },
  {
    title: "What Is TMS Therapy?",
    href: "/contents/tms/what-is-tms-therapy",
    description: "How transcranial magnetic stimulation works for depression",
  },
  {
    title: "Cost & Insurance",
    href: "/cost-insurance",
    description: "Benefits verification, CPT codes, and self-pay options",
  },
  {
    title: "Am I a Candidate?",
    href: "/am-i-a-candidate",
    description: "Screening factors for TMS and SAINT® eligibility",
  },
  {
    title: "Schedule a Consultation",
    href: "/contactus",
    description: "Book a free consultation with our clinical team",
  },
  {
    title: "Contact & Directions",
    href: "/contactus",
    description: "9734 W Sample Rd, Coral Springs, FL 33065",
  },
];

const LearnHub = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-20">
        {/* Hero */}
        <section className="border-b border-border bg-card/30">
          <div className="mx-auto max-w-4xl px-4 py-12 sm:py-16">
            <nav aria-label="Breadcrumb" className="mb-4">
              <ol className="flex items-center gap-1 text-xs text-muted-foreground">
                <li>
                  <Link to="/" className="hover:text-accent">
                    Home
                  </Link>
                </li>
                <ChevronRight className="h-3 w-3 text-muted-foreground/50" />
                <li className="font-medium text-foreground">
                  Patient Education
                </li>
              </ol>
            </nav>
            <h1 className="font-headings text-3xl font-extrabold leading-tight text-primary sm:text-4xl">
              Patient Education
            </h1>
            <p className="mt-4 text-lg leading-relaxed text-foreground">
              Plain-language guides on TMS, SAINT® TMS, accelerated TMS,
              Spravato®, treatment-resistant depression, and how these
              treatments compare. Each article answers the questions patients
              ask most — written in clear language, with sources cited.
            </p>
          </div>
        </section>

        {/* Article list */}
        <section className="py-8 sm:py-12">
          <div className="mx-auto max-w-4xl px-4">
            <div className="space-y-4">
              {allPages.map((page, i) => (
                <Link
                  key={i}
                  to={page.canonical}
                  className="group block rounded-xl border border-border bg-card p-5 shadow-soft transition-all hover:border-accent/40 hover:shadow-premium sm:p-6"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex-1">
                      <h2 className="font-headings text-lg font-bold text-primary group-hover:text-accent transition-colors sm:text-xl">
                        {page.h1}
                      </h2>
                      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                        {page.shortAnswer}
                      </p>
                    </div>
                    <ChevronRight className="mt-1 h-5 w-5 shrink-0 text-accent opacity-50 transition-all group-hover:translate-x-1 group-hover:opacity-100" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gradient-to-br from-primary to-primary-deep py-12 text-center text-white">
          <div className="mx-auto max-w-2xl px-4">
            <h2 className="font-headings text-2xl font-bold sm:text-3xl">
              Have questions about your treatment options?
            </h2>
            <p className="mt-3 text-white/90">
              Our clinical team is here to help. A free consultation is the best
              way to get answers specific to your situation.
            </p>
            <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/contactus"
                className="inline-flex items-center justify-center rounded-lg bg-accent px-6 py-3 text-sm font-bold text-accent-foreground shadow-glow transition-all hover:opacity-90"
              >
                Request a Free Consultation
              </Link>
              <a
                href="tel:9548279793"
                className="inline-flex items-center justify-center gap-2 rounded-lg border border-white/30 px-6 py-3 text-sm font-bold text-white transition-all hover:bg-white/10"
              >
                <Phone className="h-4 w-4" />
                Call 954-827-9793
              </a>
            </div>
          </div>
        </section>

        <RelatedPages heading="Related Resources" links={sharedRelated} />
      </main>
      <Footer />
    </div>
  );
};

export default LearnHub;
